import { AbstractHistogram } from 'hdr-histogram-js'
import { SerializedHistogram } from '../SerializedHistogram'
import { EnvironmentReport, mergeEnvironmentReports } from './EnvironmentReport'
import { convertHistograms, ServiceReport } from './ServiceReport'

export interface DailyReport<HISTOGRAM> {
    applicationId: number
    day: string
    environmentReports: { [key: string]: EnvironmentReport<HISTOGRAM> }
}

export const mergeDailyReports = (reports: Array<DailyReport<AbstractHistogram>>): DailyReport<AbstractHistogram> => {
    const [aggregated, ...rest] = reports

    rest.map(report => {
        Object.keys(report.environmentReports).map(environment => {
            if (aggregated.environmentReports[environment]) {
                aggregated.environmentReports[environment] = mergeEnvironmentReports([
                    aggregated.environmentReports[environment],
                    report.environmentReports[environment],
                ])

                return
            }

            aggregated.environmentReports[environment] = report.environmentReports[environment]
        })
    })

    return aggregated
}
export const allServiceReportsFromDailyReport = (report: DailyReport<AbstractHistogram>): Array<ServiceReport<AbstractHistogram>> => {
    let serviceReports: Array<ServiceReport<AbstractHistogram>> = []

    Object.keys(report.environmentReports).map(env =>
        Object.keys(report.environmentReports[env].serviceReports).map(service => {
            serviceReports = [...serviceReports, report.environmentReports[env].serviceReports[service]]
        }),
    )

    return serviceReports
}

export const convertHistogramsDailyReport = (report: DailyReport<SerializedHistogram>): DailyReport<AbstractHistogram> => {
    const environmentReports = {}
    Object.keys(report.environmentReports).map(env => {
        const serviceReports = {}
        Object.keys(report.environmentReports[env].serviceReports).map(service => {
            serviceReports[service] = convertHistograms(report.environmentReports[env].serviceReports[service])
        })
        environmentReports[env] = {
            ...report.environmentReports[env],
            serviceReports,
        }
    })

    return {
        ...report,
        environmentReports,
    }
}
